import { CommonModule } from '@angular/common';
import { Component, NgModule, OnInit } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { LinkModule } from '@app/directives/link.directive';

@Component({
  selector: 'app-app-tile-hide-dialog',
  templateUrl: './app-tile-hide-dialog.component.html',
  styleUrls: ['./app-tile-hide-dialog.component.scss']
})
export class AppTileHideDialogComponent implements OnInit {

  constructor(public dialogRef: MatDialogRef<AppTileHideDialogComponent>) {
  }

  hide() {
    this.dialogRef.close(true);
  }

  ngOnInit(): void {
  }
}
@NgModule({
  declarations: [
    AppTileHideDialogComponent
  ],
  entryComponents: [
    AppTileHideDialogComponent
  ],
  imports: [
    CommonModule,
    LinkModule,
    MatDialogModule,
    MatButtonModule
  ]
})
export class AppTileHideDialogModule { }
